/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    const theme_dir = './../../wp-content/themes/adrighem';

    /// isOnScreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    /// load foundation
    $(document).foundation();

    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if (scroll > 1) {
            $('.navbar').addClass('scroll');
            $('.usps-nav').addClass('scroll');
        } else {
            $('.navbar').removeClass('scroll');
            $('.usps-nav').removeClass('scroll');
        }

        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    }

    scroll_function($(window).scrollTop());

    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();
        scroll_function(scroll);
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }

    lazy();

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                 var delay = $(this).attr('data-delay');

                if(delay === 0){
                    delay = 150;
                }else{
                    delay = $(this).attr('data-delay');
                }

                if (speed === null) {
                    speed = 500;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    };

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    $('.liquid').imgLiquid();

    function initLogoSlider() {
        $('.logo-slider__slider').slick({
            infinite: true,
            arrows: true,
            adaptiveHeight: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: '<span class="slick-arrow--previous"><img class="slick-arrow__image" src="/adrighem/wp-content/themes/adrighem/assets/dist/images/icons/icon-arrow-left.png" alt="Previous"></span>',
            nextArrow: '<span class="slick-arrow--next"><img class="slick-arrow__image" src="/adrighem/wp-content/themes/adrighem/assets/dist/images/icons/icon-arrow-right.png" alt="Next"></span>',
            responsive: [{
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    }
    initLogoSlider();

    /* Slider */
    //
    // Product detail page
    //

    $('.project-slider').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<span class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
        nextArrow: '<span class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
        responsive: [{
            breakpoint: 450,
            settings: {
                adaptiveHeight: true
            }
        }]
    });

    function initProductSlider() {
        var $currentImage = $('.product-images__paging-count'),
            $totalImageCount = $('.product-images__paging-total'),
            $slickElement = $('.product-images__slider');

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;

            $currentImage.text(i);
            $totalImageCount.text(slick.slideCount);
        });

        $slickElement.slick({
            infinite: true,
            arrows: true,
            dots: true,
            appendDots: $('.product-images__dots'),
            autoplay: true,
            prevArrow: '<span class="slick-arrow--previous"><i class="far fa-fw fa-arrow-alt-circle-left"></i></span>',
            nextArrow: '<span class="slick-arrow--next"><i class="far fa-fw fa-arrow-alt-circle-right"></i></span>',
        });
    }
    initProductSlider();

    function initMenu() {
        // Add correct classes to main menu items with submenu
        $('.menu__submenu').each(function () {
            var $submenu = $(this),
                $parentItem = $submenu.parent(),
                $menuLink = $parentItem.find('.menu__link');

            $parentItem.addClass('menu__item--has-submenu');
            $menuLink.append('<span class="menu__dropdown-icon"></span>');
        });

        $('.menu__submenu-item--active').closest('.menu__item').addClass('menu__item--active-submenu-item');
    }
    initMenu();


    // Search results

    function searchBarHandler() {
        var initSuggestion = false;

        $('.search-bar__form .form__input').keyup(function () {
            var $formInput = $(this),
                $searchResultDropdown = $('.search-result'),
                $searchResultOverlay = $('.search-result__overlay'),
                $searchResultCloseButton = $('.search-result__close');

            if ($formInput.val().length == 0 || $searchResultDropdown.css('display') == 'none') {
                $searchResultOverlay.removeClass('search-result__overlay--show');
            } else {
                $searchResultOverlay.addClass('search-result__overlay--show');

                $searchResultCloseButton.click(function () {
                    $formInput.val('');
                    $searchResultDropdown.hide();
                    $searchResultOverlay.removeClass('search-result__overlay--show');
                    initSuggestion = false;
                });
            }

            searchBarSuggestionHandler($formInput);
            initSuggestion = true;
        });
    }
    searchBarHandler();

    function searchBarSuggestionHandler(formInput) {
        $('.search-result .search-result__suggestion-link').click((e) => {
            var $element = $(e.target),
                $formInput = $(formInput),
                value = $element.html();
        });
    }

    function toggleProductFilter() {
        $('.products .products__filter-item').click((e) => {
            var $element = $(e.target),
                $filterItem = $element.closest('.products__filter-item');

            $filterItem.toggleClass('products__filter-item--selected');
        });
    }
    toggleProductFilter();

    function populateBookingFields() {
        const $form = $('.product-booking__form'),
            name = $('.page-title__title').html(),
            url = window.location.href,
            $nameInput = $form.find('.js-product-booking__name'),
            $urlInput = $form.find('.js-product-booking__url');

        $nameInput.val(name);
        $urlInput.val(url);
    }
    populateBookingFields();

    function emailIsValid (email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    function onSubmitBookingForm() {
        $('.product-booking__form').submit((e) => {
            const $form = $(e.target), serializedForm = $form.serialize();
            var send = true;
            e.preventDefault();

            var contact_person = $('#contact_person').val();
            var phone_number = $('#phone_number').val();
            var emailadress = $('#emailadress').val();
            var company_name = $('#company_name').val();

            if(company_name === '' || company_name === undefined) {
                $('#company_name').addClass('redborder');
                send = false;
            }

            if(contact_person === '' || contact_person === undefined){
                $('#contact_person').addClass('redborder');
                send = false;
            }else{
                $('#contact_person').removeClass('redborder');
            }

            if(phone_number === '' || phone_number === undefined){
                $('#phone_number').addClass('redborder');
                send = false;
            }else{
                $('#phone_number').removeClass('redborder');
            }

            if(emailadress === '' || emailadress === undefined){
                $('#emailadress').addClass('redborder');
                send = false;
            }else{

                if(emailIsValid(emailadress)){
                    $('#emailadress').removeClass('redborder');
                }else{
                    $('#emailadress').addClass('redborder');
                    send = false;
                }
            }

            if(send === false){
                return false;
            }

            $.ajax({
                url: theme_dir + '/ajax/ajax-submit-form-handler.php',
                method: 'POST',
                data: serializedForm,
                dataType: 'json'
            }).fail((jqXHR, textStatus) => {
                console.log(textStatus);

                return false;
            }).done((resp) => {
                if (resp) {
                    var responseType = resp.type,
                        responseTitle = resp.title,
                        responseMessage = resp.message;

                    Swal.fire({
                        type: responseType,
                        title: responseTitle,
                        text: responseMessage
                    });

                    if(resp.type === 'success'){
                        window.location.replace(thankspage);
                    }

                    return true;
                }

                return false;
            });
        });
    }
    onSubmitBookingForm();

    $('.pointbtn').click(function(){
       var id = $(this).attr('data-id');
       $('.pointbtn').removeClass('active');
       $(this).addClass('active');

       var data = {
           data : id
       };

        $.ajax({
            url: 'http://localhost/adrighem/wp-content/themes/adrighem/ajax/getProject.php',
            // url: theme_dir + '/ajax/getProject.php',
            method: 'POST',
            data: data,
        }).fail((jqXHR, textStatus) => {
            console.log(textStatus);

            return false;
        }).done((resp) => {
            resp = JSON.parse(resp);

            $('.project-title').html(resp.title);
            $('.project-subtitle').html(resp.location);
            $('.project-content').html(resp.description);
            $('.project-img').attr('src', resp.image);
            $('.liquid').imgLiquid();

            //project-display

            if ($(window).width() < 1300) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".project-display .categories__title").offset().top -20
                }, 800);
            }

            return true;
        });
    });

    $('.related-banners__description').matchHeight();
    $('h3.categories__name').matchHeight();
    $('.banners--related .banners__inner').matchHeight();
    $('.product-cat-mh').matchHeight();
    $('.post-title-mh').matchHeight();
    $('.mh-post-content').matchHeight();


    if($('body').hasClass('single')){
        window.addEventListener('DOMContentLoaded',function(){
            new SmartPhoto(".js-smartPhoto");
        });
    }



    $(document).ready(function(){
        $('.white-overlay').fadeOut();
    });

    $('.product-booking__form .types .type').click(function(){
        var value = $(this).attr('data-value')
        $('.product-booking__form .types .type.active').removeClass('active');
        $(this).addClass('active');
        $('.product-booking__form input[name="interest"]').val(value);
    });

    $('.products .mobile_filter').click(function(){
        $('.products__sidebar-inner').toggleClass('show');
    });

    $('.ais-hits--item .products__item').matchHeight();

    setTimeout(function(){
        $('.ais-hits--item .products__item').matchHeight();
    }, 800);

    $('.product-category__filter-options .inner').matchHeight({byRow : false});

    $('.product-category__filter-name').matchHeight();

    setTimeout(function(){
        $('.contact-float').addClass('up');
    }, 3500)

})(jQuery); // Fully reference jQuery after this point.